import { useEffect, useRef, useState } from "react";
import { useIsOpenSidebar, useIsOpenSidebarAction } from "../../context/toggleSidebarContext";
import { useAuth } from "../../context/AuthContext";
import { logout, setReturnToAdmin } from "../../services";
import { Link, useNavigate } from "react-router-dom";
import Loading from "../Loading";
import { getMessage } from "@testing-library/jest-dom/dist/utils";
export default function HeaderPublic({ notifications, getMessage }) {
    const [isShowDropdownUser, setIsShowDropdownUser] = useState(false);
    const [isShowDropdownNotification, setIsShowDropdownNotification] = useState(false);
    const [isShowDropdownLanguage, setIsShowDropdownLanguage] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);
    const dropdownUserRef = useRef(null);
    const dropdownNotificationRef = useRef(null);
    const dropdownLanguageRef = useRef(null);
    const [isLoading, setIsLoading] = useState(false);
    const navigate = useNavigate();
    const setIsOpenSidebar = useIsOpenSidebarAction()
    const isOpenSidebar = useIsOpenSidebar();

    const { user } = useAuth();

    useEffect(() => {
        document.addEventListener('mousedown', handleDropdownUser);
        document.addEventListener('mousedown', handleDropdownNotification);
        document.addEventListener('mousedown', handleDropdownLanguage);
        window.addEventListener("scroll", handleScroll);

        return () => {
            document.removeEventListener('mousedown', handleDropdownUser);
            document.removeEventListener('mousedown', handleDropdownLanguage);
            document.removeEventListener('mousedown', handleDropdownNotification);
            window.removeEventListener("scroll", handleScroll);
        };


    }, [])

    const handleScroll = () => {
        if (document.body.scrollTop > 10 || document.documentElement.scrollTop > 10) {
            setIsScrolled(true);
        } else {
            setIsScrolled(false)
        }
    }

    const handleDropdownUser = (e) => {
        if (dropdownUserRef?.current && !dropdownUserRef.current.contains(e.target)) {
            setIsShowDropdownUser(false)
        }
    }
    const handleDropdownNotification = (e) => {
        if (dropdownNotificationRef?.current && !dropdownNotificationRef.current.contains(e.target)) {
            setIsShowDropdownNotification(false)
        }
    }
    const handleDropdownLanguage = (e) => {
        if (dropdownLanguageRef?.current && !dropdownLanguageRef.current.contains(e.target)) {
            setIsShowDropdownLanguage(false)
        }
    }
    const handelReturnAdmin = () => {
        setReturnToAdmin()
        navigate('/dashboard');
        window.location.reload()
    }
    const handleLogout = async () => {
        setIsLoading(true);
        try {
            const { isSuccess } = await logout();
            if (isSuccess) {
                navigate('/login')
            }
            setIsLoading(false)
        } catch (ex) {
            console.log(ex);
            setIsLoading(false);
        }
    }
    const showNotification = async (id) => {
        getMessage(id);
    }

    return (
        <>
            <nav className={`layout-navbar navbar navbar-expand-xl align-items-center bg-navbar-theme ${isScrolled ? "navbar-elevated" : ""}`} id="layout-navbar">
                <div className="container-fluid">

                    <div className="layout-menu-toggle navbar-nav align-items-xl-center me-3 me-xl-0 d-xl-none"
                        onClick={() => setIsOpenSidebar({ ...isOpenSidebar, expanded: true })}>
                        <button className="nav-item nav-link px-0 me-xl-4 bg-transparent border-0">
                            <i className="bx bx-menu bx-sm" />
                        </button>
                    </div>


                    <div className="navbar-nav-right d-flex align-items-center" id="navbar-collapse">
                        <ul className="navbar-nav flex-row align-items-center ms-auto">
                            <li className="nav-item me-2 me-xl-0">

                                <button className="nav-link style-switcher-toggle hide-arrow border-0 bg-transparent">
                                    <div>{!((localStorage.getItem('adminToken') === 'null') || (localStorage.getItem('adminToken') === null)) ? <span onClick={handelReturnAdmin}>ادمین<i className="bx  bx-arrow-back" /> </span> : ""}</div>
                                </button>
                            </li>
                            {/*<li className="nav-item dropdown-language dropdown me-2 me-xl-0">*/}
                            {/*    <button className="nav-link dropdown-toggle hide-arrow" onClick={() => setIsShowDropdownLanguage(prevState => !prevState)} ref={dropdownLanguageRef}>*/}
                            {/*        <i className="fi fi-ir fis rounded-circle fs-3 me-1"></i>*/}
                            {/*    </button>*/}
                            {/*    <ul className={`dropdown-menu dropdown-menu-end ${isShowDropdownLanguage ? "show" : ""}`} data-bs-popper="none">*/}
                            {/*        <li>*/}
                            {/*            <a className="dropdown-item" data-language="fa">*/}
                            {/*                <i className="fi fi-ir fis rounded-circle fs-4 me-1"></i>*/}
                            {/*                <span className="align-middle">فارسی</span>*/}
                            {/*            </a>*/}
                            {/*        </li>*/}
                            {/*        <li>*/}
                            {/*            <a className="dropdown-item" data-language="en">*/}
                            {/*                <i className="fi fi-us fis rounded-circle fs-4 me-1"></i>*/}
                            {/*                <span className="align-middle">انگلیسی</span>*/}
                            {/*            </a>*/}
                            {/*        </li>*/}

                            {/*    </ul>*/}
                            {/*</li>*/}

                            <li className="nav-item dropdown-notifications navbar-dropdown dropdown me-3 me-xl-2" ref={dropdownNotificationRef}>
                                <Link to={`/login`} className={"menu-toggle"}>
                                    <div style={{ color: 'white' }}>ورود / ثبت نام</div>
                                </Link>
                                <ul className={`dropdown-menu dropdown-menu-end py-0 ${isShowDropdownNotification ? "show" : ""}`} data-bs-popper="none">
                                    <li className="dropdown-menu-header border-bottom-2">
                                        <div className="dropdown-header d-flex align-items-center py-1">
                                            <h5 className="text-body mb-0 me-auto secondary-font">اعلان‌ها</h5>
                                        </div>
                                    </li>
                                    {/* {notifications.some(_ => true) ?
                                        <li className="dropdown-notifications-list scrollable-container" style={{overflowY: 'auto'}}>
                                            <ul className="list-group list-group-flush">
                                                {notifications.map(x =>
                                                    <li key={x.id} onClick={() => showNotification(x.id)} className="list-group-item list-group-item-action dropdown-notifications-item">
                                                        <div className="d-flex">
                                                            <div className="flex-grow-1">
                                                                <p className="mb-0 not-text">{x.text}</p>
                                                            </div>
                                                            <div className="flex-shrink-0 dropdown-notifications-actions">
                                                            <span className="dropdown-notifications-read">
                                                                {!x.seen ? <span className="badge badge-dot bg-danger"></span> : null}
                                                            </span>
                                                            </div>
                                                        </div>
                                                    </li>
                                                )}
                                            </ul>
                                        </li>
                                    :
                                        <li className="dropdown-menu-footer border-top">
                                            <a
                                               className="dropdown-item d-flex justify-content-center p-3">
                                                هیچ پیامی ندارید
                                            </a>
                                        </li>
                                    } */}
                                </ul>
                            </li>

                            <li className="nav-item navbar-dropdown dropdown-user dropdown">
                                {/*onClick={() => setIsShowDropdownUser(prevState => !prevState)} ref={dropdownUserRef}>*/}
                                {/*<button className={`nav-link dropdown-toggle hide-arrow bg-transparent border-0 ${isShowDropdownUser ? "show" : ""}`}*/}
                                {/*   data-bs-toggle="dropdown">*/}
                                <Link to="/" className={`app-brand-link mx-auto ${isOpenSidebar.collapsed && !isOpenSidebar.expanded && !isOpenSidebar.hovered ? "ms-n4" : ""}`}>
                                    {/*<span className="app-brand-logo demo">*/}
                                    {/*     <img src="/logo.png" alt="logo"/>*/}
                                    {/*  </span>*/}
                                    {/*<span className="app-brand-text demo menu-text fw-bold ms-2 display-8">آجیل برادران حسینی</span>*/}
                                </Link>
                                {/*</button>*/}
                                <ul className={`dropdown-menu dropdown-menu-end ${isShowDropdownUser ? "show" : ""}`}
                                    data-bs-popper="none">
                                    <li>
                                        <div className="dropdown-item">
                                            <div className="d-flex align-items-center">
                                                <div className="flex-shrink-0 me-3">
                                                    <div className="avatar avatar-online mt-1">
                                                        <img src="/avatars/1.png" alt="avatar"
                                                            className="rounded-circle" />
                                                    </div>
                                                </div>
                                                <div className="flex-grow-1">
                                                    <span className="fw-semibold d-block">{`${user?.userInfo?.data?.firstName} ${user?.userInfo?.data?.lastName}`}</span>
                                                    {/*<small>مدیر</small>*/}
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="dropdown-divider" />
                                    </li>
                                    <li>
                                        <button className="dropdown-item" onClick={handleLogout}>
                                            <i className="bx bx-power-off me-2" />
                                            <span className="align-middle">خروج</span>
                                        </button>
                                    </li>
                                </ul>
                            </li>

                        </ul>
                    </div>

                </div>
            </nav>
            {
                isLoading ? (<Loading />) : null
            }
        </>
    )
}